import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Card from "../generic/Card";

function Overview() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const overviewItems = [
    {
      id: "participants",
      icon: "fas fa-users",
      title: t("overview.participants.title"),
      description: t("overview.participants.description"),
    },
    {
      id: "nations",
      icon: "fas fa-flag",
      title: t("overview.nations.title"),
      description: t("overview.nations.description"),
    },
    {
      id: "live_show",
      icon: "fas fa-star",
      title: t("overview.live_show.title"),
      description: t("overview.live_show.description"),
    },
    {
      id: "cultural_exchange",
      icon: "fas fa-comments",
      title: t("overview.cultural_exchange.title"),
      description: t("overview.cultural_exchange.description"),
    },
  ];

  const handleLearnMoreClick = () => {
    navigate("/taolu");
    window.scrollTo(0, 0);
  };

  return (
    <section
      className="pt-12 pb-12 bg-slate-50/50 dark:bg-slate-900 transition-colors relative z-10"
      id="about"
      aria-labelledby="overview-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="overview-heading"
            className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block font-semibold tracking-tight"
          >
            {t("overview.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 -translate-x-1/2 w-16 h-0.5 bg-primary dark:bg-primary-light rounded-full"
              aria-hidden
            />
          </h2>
          <p className="text-pretty text-slate-600 dark:text-slate-400 mt-5 text-lg max-w-3xl mx-auto leading-relaxed">
            {t("overview.description")}
          </p>
        </header>

        <ul className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 md:gap-6 mb-10 list-none p-0 m-0">
          {overviewItems.map((item) => (
            <li key={item.id} className="min-h-0">
              <Card
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            </li>
          ))}
        </ul>

        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleLearnMoreClick}
            className="inline-flex items-center gap-2 px-5 py-2.5 md:px-6 md:py-3 bg-primary dark:bg-primary-light text-white text-sm font-medium rounded-xl hover:bg-primary-dark dark:hover:bg-primary transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary/40 dark:focus-visible:ring-primary-light/40 dark:focus-visible:ring-offset-slate-900 shadow-sm hover:shadow"
          >
            <span>{t("button.see_more")}</span>
            <i className="fas fa-arrow-right text-xs opacity-90" aria-hidden />
          </button>
        </div>
      </div>
    </section>
  );
}

export default Overview;

